import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface TeamProfile {
  id: number;
  nameKey: string;
  roleKey: string;
  bioKey: string;
  image: string;
  imageAltKey: string;
}

@Component({
  selector: 'pwj-team-page',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './team-page.component.html',
  styleUrl: './team-page.component.scss',
})
export class TeamPageComponent {
  public readonly teamProfiles: TeamProfile[] = [
    {
      id: 1,
      nameKey: 'teamPage.members.member1.name',
      roleKey: 'teamPage.members.member1.role',
      bioKey: 'teamPage.members.member1.bio',
      image: 'assets/images/team/first-member.jpg',
      imageAltKey: 'teamPage.members.member1.imageAlt',
    },
    {
      id: 2,
      nameKey: 'teamPage.members.member2.name',
      roleKey: 'teamPage.members.member2.role',
      bioKey: 'teamPage.members.member2.bio',
      image: 'assets/images/team/second-member.jpg',
      imageAltKey: 'teamPage.members.member2.imageAlt',
    },
    {
      id: 3,
      nameKey: 'teamPage.members.member3.name',
      roleKey: 'teamPage.members.member3.role',
      bioKey: 'teamPage.members.member3.bio',
      image: 'assets/images/team/third-member.jpg',
      imageAltKey: 'teamPage.members.member3.imageAlt',
    },
  ];
}
